/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import { EventAbnormalTermination } from './event-abnormal-termination';
import { EventActivityChange } from './event-activity-change';
import { EventHttp } from './event-http';
import { EventIOSAction } from './event-iosaction';
import { EventInteractive } from './event-interactive';
import { EventKeep } from './event-keep';
import { EventKeyboardVisibility } from './event-keyboard-visibility';
import { EventLog } from './event-log';
import { EventSecondaryNavChange } from './event-secondary-nav-change';
import { EventUserActivity } from './event-user-activity';
import { FSEventConsent } from './fsevent-consent';
import { FSEventPerformanceCounters } from './fsevent-performance-counters';
import { FSEventSetVarBool } from './fsevent-set-var-bool';
import { FSEventSetVarDate } from './fsevent-set-var-date';
import { FSEventSetVarDateISO } from './fsevent-set-var-date-iso';
import { FSEventSetVarInt } from './fsevent-set-var-int';
import { FSEventSetVarReal } from './fsevent-set-var-real';
import { FSEventSetVarStr } from './fsevent-set-var-str';
import { FSEventSysHighlight } from './fsevent-sys-highlight';
import { FSFBEventAnonymize } from './fsfbevent-anonymize';
import { FSFBEventCustom } from './fsfbevent-custom';
import { FSFBEventLowMemory } from './fsfbevent-low-memory';
import { FSFBEventSetSessionData } from './fsfbevent-set-session-data';
import { FSFBEventSetVars } from './fsfbevent-set-vars';
import { FSFBEventUnmatchedSelectorGroup } from './fsfbevent-unmatched-selector-group';

export enum FSEvent {
  NONE = 0,
  FSEventSysHighlight = 1,
  FSEventSetVarStr = 2,
  FSEventSetVarDate = 3,
  FSEventSetVarReal = 4,
  FSEventSetVarBool = 5,
  FSEventSetVarInt = 6,
  EventLog = 7,
  EventInteractive = 8,
  EventActivityChange = 9,
  EventIOSAction = 10,
  EventKeyboardVisibility = 11,
  FSEventConsent = 12,
  FSFBEventCustom = 13,
  FSFBEventSetVars = 14,
  FSEventPerformanceCounters = 15,
  FSFBEventAnonymize = 16,
  FSFBEventSetSessionData = 17,
  FSFBEventLowMemory = 18,
  EventUserActivity = 19,
  EventKeep = 20,
  EventSecondaryNavChange = 21,
  EventHttp = 22,
  FSEventSetVarDateISO = 23,
  EventAbnormalTermination = 24,
  FSFBEventUnmatchedSelectorGroup = 25,
}

export function unionToFsevent(
  type: FSEvent,
  accessor: (
    obj:
      | EventAbnormalTermination
      | EventActivityChange
      | EventHttp
      | EventIOSAction
      | EventInteractive
      | EventKeep
      | EventKeyboardVisibility
      | EventLog
      | EventSecondaryNavChange
      | EventUserActivity
      | FSEventConsent
      | FSEventPerformanceCounters
      | FSEventSetVarBool
      | FSEventSetVarDate
      | FSEventSetVarDateISO
      | FSEventSetVarInt
      | FSEventSetVarReal
      | FSEventSetVarStr
      | FSEventSysHighlight
      | FSFBEventAnonymize
      | FSFBEventCustom
      | FSFBEventLowMemory
      | FSFBEventSetSessionData
      | FSFBEventSetVars
      | FSFBEventUnmatchedSelectorGroup,
  ) =>
    | EventAbnormalTermination
    | EventActivityChange
    | EventHttp
    | EventIOSAction
    | EventInteractive
    | EventKeep
    | EventKeyboardVisibility
    | EventLog
    | EventSecondaryNavChange
    | EventUserActivity
    | FSEventConsent
    | FSEventPerformanceCounters
    | FSEventSetVarBool
    | FSEventSetVarDate
    | FSEventSetVarDateISO
    | FSEventSetVarInt
    | FSEventSetVarReal
    | FSEventSetVarStr
    | FSEventSysHighlight
    | FSFBEventAnonymize
    | FSFBEventCustom
    | FSFBEventLowMemory
    | FSFBEventSetSessionData
    | FSFBEventSetVars
    | FSFBEventUnmatchedSelectorGroup
    | null,
):
  | EventAbnormalTermination
  | EventActivityChange
  | EventHttp
  | EventIOSAction
  | EventInteractive
  | EventKeep
  | EventKeyboardVisibility
  | EventLog
  | EventSecondaryNavChange
  | EventUserActivity
  | FSEventConsent
  | FSEventPerformanceCounters
  | FSEventSetVarBool
  | FSEventSetVarDate
  | FSEventSetVarDateISO
  | FSEventSetVarInt
  | FSEventSetVarReal
  | FSEventSetVarStr
  | FSEventSysHighlight
  | FSFBEventAnonymize
  | FSFBEventCustom
  | FSFBEventLowMemory
  | FSFBEventSetSessionData
  | FSFBEventSetVars
  | FSFBEventUnmatchedSelectorGroup
  | null {
  switch (FSEvent[type]) {
    case 'NONE':
      return null;
    case 'FSEventSysHighlight':
      return accessor(new FSEventSysHighlight())! as FSEventSysHighlight;
    case 'FSEventSetVarStr':
      return accessor(new FSEventSetVarStr())! as FSEventSetVarStr;
    case 'FSEventSetVarDate':
      return accessor(new FSEventSetVarDate())! as FSEventSetVarDate;
    case 'FSEventSetVarReal':
      return accessor(new FSEventSetVarReal())! as FSEventSetVarReal;
    case 'FSEventSetVarBool':
      return accessor(new FSEventSetVarBool())! as FSEventSetVarBool;
    case 'FSEventSetVarInt':
      return accessor(new FSEventSetVarInt())! as FSEventSetVarInt;
    case 'EventLog':
      return accessor(new EventLog())! as EventLog;
    case 'EventInteractive':
      return accessor(new EventInteractive())! as EventInteractive;
    case 'EventActivityChange':
      return accessor(new EventActivityChange())! as EventActivityChange;
    case 'EventIOSAction':
      return accessor(new EventIOSAction())! as EventIOSAction;
    case 'EventKeyboardVisibility':
      return accessor(new EventKeyboardVisibility())! as EventKeyboardVisibility;
    case 'FSEventConsent':
      return accessor(new FSEventConsent())! as FSEventConsent;
    case 'FSFBEventCustom':
      return accessor(new FSFBEventCustom())! as FSFBEventCustom;
    case 'FSFBEventSetVars':
      return accessor(new FSFBEventSetVars())! as FSFBEventSetVars;
    case 'FSEventPerformanceCounters':
      return accessor(new FSEventPerformanceCounters())! as FSEventPerformanceCounters;
    case 'FSFBEventAnonymize':
      return accessor(new FSFBEventAnonymize())! as FSFBEventAnonymize;
    case 'FSFBEventSetSessionData':
      return accessor(new FSFBEventSetSessionData())! as FSFBEventSetSessionData;
    case 'FSFBEventLowMemory':
      return accessor(new FSFBEventLowMemory())! as FSFBEventLowMemory;
    case 'EventUserActivity':
      return accessor(new EventUserActivity())! as EventUserActivity;
    case 'EventKeep':
      return accessor(new EventKeep())! as EventKeep;
    case 'EventSecondaryNavChange':
      return accessor(new EventSecondaryNavChange())! as EventSecondaryNavChange;
    case 'EventHttp':
      return accessor(new EventHttp())! as EventHttp;
    case 'FSEventSetVarDateISO':
      return accessor(new FSEventSetVarDateISO())! as FSEventSetVarDateISO;
    case 'EventAbnormalTermination':
      return accessor(new EventAbnormalTermination())! as EventAbnormalTermination;
    case 'FSFBEventUnmatchedSelectorGroup':
      return accessor(new FSFBEventUnmatchedSelectorGroup())! as FSFBEventUnmatchedSelectorGroup;
    default:
      return null;
  }
}

export function unionListToFsevent(
  type: FSEvent,
  accessor: (
    index: number,
    obj:
      | EventAbnormalTermination
      | EventActivityChange
      | EventHttp
      | EventIOSAction
      | EventInteractive
      | EventKeep
      | EventKeyboardVisibility
      | EventLog
      | EventSecondaryNavChange
      | EventUserActivity
      | FSEventConsent
      | FSEventPerformanceCounters
      | FSEventSetVarBool
      | FSEventSetVarDate
      | FSEventSetVarDateISO
      | FSEventSetVarInt
      | FSEventSetVarReal
      | FSEventSetVarStr
      | FSEventSysHighlight
      | FSFBEventAnonymize
      | FSFBEventCustom
      | FSFBEventLowMemory
      | FSFBEventSetSessionData
      | FSFBEventSetVars
      | FSFBEventUnmatchedSelectorGroup,
  ) =>
    | EventAbnormalTermination
    | EventActivityChange
    | EventHttp
    | EventIOSAction
    | EventInteractive
    | EventKeep
    | EventKeyboardVisibility
    | EventLog
    | EventSecondaryNavChange
    | EventUserActivity
    | FSEventConsent
    | FSEventPerformanceCounters
    | FSEventSetVarBool
    | FSEventSetVarDate
    | FSEventSetVarDateISO
    | FSEventSetVarInt
    | FSEventSetVarReal
    | FSEventSetVarStr
    | FSEventSysHighlight
    | FSFBEventAnonymize
    | FSFBEventCustom
    | FSFBEventLowMemory
    | FSFBEventSetSessionData
    | FSFBEventSetVars
    | FSFBEventUnmatchedSelectorGroup
    | null,
  index: number,
):
  | EventAbnormalTermination
  | EventActivityChange
  | EventHttp
  | EventIOSAction
  | EventInteractive
  | EventKeep
  | EventKeyboardVisibility
  | EventLog
  | EventSecondaryNavChange
  | EventUserActivity
  | FSEventConsent
  | FSEventPerformanceCounters
  | FSEventSetVarBool
  | FSEventSetVarDate
  | FSEventSetVarDateISO
  | FSEventSetVarInt
  | FSEventSetVarReal
  | FSEventSetVarStr
  | FSEventSysHighlight
  | FSFBEventAnonymize
  | FSFBEventCustom
  | FSFBEventLowMemory
  | FSFBEventSetSessionData
  | FSFBEventSetVars
  | FSFBEventUnmatchedSelectorGroup
  | null {
  switch (FSEvent[type]) {
    case 'NONE':
      return null;
    case 'FSEventSysHighlight':
      return accessor(index, new FSEventSysHighlight())! as FSEventSysHighlight;
    case 'FSEventSetVarStr':
      return accessor(index, new FSEventSetVarStr())! as FSEventSetVarStr;
    case 'FSEventSetVarDate':
      return accessor(index, new FSEventSetVarDate())! as FSEventSetVarDate;
    case 'FSEventSetVarReal':
      return accessor(index, new FSEventSetVarReal())! as FSEventSetVarReal;
    case 'FSEventSetVarBool':
      return accessor(index, new FSEventSetVarBool())! as FSEventSetVarBool;
    case 'FSEventSetVarInt':
      return accessor(index, new FSEventSetVarInt())! as FSEventSetVarInt;
    case 'EventLog':
      return accessor(index, new EventLog())! as EventLog;
    case 'EventInteractive':
      return accessor(index, new EventInteractive())! as EventInteractive;
    case 'EventActivityChange':
      return accessor(index, new EventActivityChange())! as EventActivityChange;
    case 'EventIOSAction':
      return accessor(index, new EventIOSAction())! as EventIOSAction;
    case 'EventKeyboardVisibility':
      return accessor(index, new EventKeyboardVisibility())! as EventKeyboardVisibility;
    case 'FSEventConsent':
      return accessor(index, new FSEventConsent())! as FSEventConsent;
    case 'FSFBEventCustom':
      return accessor(index, new FSFBEventCustom())! as FSFBEventCustom;
    case 'FSFBEventSetVars':
      return accessor(index, new FSFBEventSetVars())! as FSFBEventSetVars;
    case 'FSEventPerformanceCounters':
      return accessor(index, new FSEventPerformanceCounters())! as FSEventPerformanceCounters;
    case 'FSFBEventAnonymize':
      return accessor(index, new FSFBEventAnonymize())! as FSFBEventAnonymize;
    case 'FSFBEventSetSessionData':
      return accessor(index, new FSFBEventSetSessionData())! as FSFBEventSetSessionData;
    case 'FSFBEventLowMemory':
      return accessor(index, new FSFBEventLowMemory())! as FSFBEventLowMemory;
    case 'EventUserActivity':
      return accessor(index, new EventUserActivity())! as EventUserActivity;
    case 'EventKeep':
      return accessor(index, new EventKeep())! as EventKeep;
    case 'EventSecondaryNavChange':
      return accessor(index, new EventSecondaryNavChange())! as EventSecondaryNavChange;
    case 'EventHttp':
      return accessor(index, new EventHttp())! as EventHttp;
    case 'FSEventSetVarDateISO':
      return accessor(index, new FSEventSetVarDateISO())! as FSEventSetVarDateISO;
    case 'EventAbnormalTermination':
      return accessor(index, new EventAbnormalTermination())! as EventAbnormalTermination;
    case 'FSFBEventUnmatchedSelectorGroup':
      return accessor(
        index,
        new FSFBEventUnmatchedSelectorGroup(),
      )! as FSFBEventUnmatchedSelectorGroup;
    default:
      return null;
  }
}
